// Hook for real-time password validation checks
import { useMemo } from 'react';
import { PASSWORD_RULES } from '../utils/passwordRules';

export const usePasswordChecks = (password) => {
  const checks = useMemo(() => {
    return PASSWORD_RULES.map((rule) => ({
      id: rule.id,
      label: rule.label,
      passed: password ? rule.validate(password) : false,
    }));
  }, [password]);

  const allPassed = useMemo(() => {
    return password.length > 0 && checks.every((check) => check.passed);
  }, [password, checks]);

  return { checks, allPassed };
};
